jQuery(function () {
  var selector = "[data-behaviour~=submit-on-change]";

  // BEHAVIOUR

  jQuery(document).on("change", selector, function () {
    jQuery(this).closest("form").trigger("submit");
  });
});
